import { createSlice } from '@reduxjs/toolkit';
const costHistoryPopoverOffsetLeft = 40;
const sharedStockInitialState = {
    costHistory: {
        open: false,
        data: undefined,
    },
    uploadPricesFileDialog: {
        open: false,
    },
    cellSelection: {
        // If cellId is undefined it means no grouping by cell selected.
        cellId: undefined,
        // `cellName` is undefined - means no grouping by cell is chosen.
        cellName: undefined,
        inactive: false,
        items: [],
    },
    cellSelection_New: {
        // `cellName` is undefined - means no grouping by cell is chosen.
        cellName: undefined,
        inactive: false,
        items: [],
    },
    balanceSelection: {
        inactive: false,
        items: [],
    },
    beingUpdatedCellId: undefined,
    relocateStockItemDialog: {
        open: false,
        relocateErrorResponse: undefined,
    },
};
const createSharedStockSlice = ({ name = 'stock', initialState, reducers, }) => {
    return createSlice({
        name,
        initialState,
        // reducers: {
        //   start(state) {
        //     state.status = 'loading'
        //   },
        //   //  * If you want to write to values of the state that depend on the generic
        //   //  * (in this case: `state.data`, which is T), you might need to specify the
        //   //  * State type manually here, as it defaults to `Draft<GenericState<T>>`,
        //   //  * which can sometimes be problematic with yet-unresolved generics.
        //   //  * This is a general problem when working with immer's Draft type and generics.
        //   success(state: GenericState<T>, action: PayloadAction<T>) {
        //     state.data = action.payload
        //     state.status = 'finished'
        //   },
        //   ...reducers,
        // },
        reducers: {
            openCostHistoryPopover: (state, action) => {
                state.costHistory.open = true;
                state.costHistory.data = action.payload;
                state.costHistory.data.position.left -= costHistoryPopoverOffsetLeft;
            },
            closeCostHistoryPopover: (state) => {
                state.costHistory.open = false;
                state.costHistory.data = undefined;
            },
            openUploadPricesFileDialog: (state) => {
                state.uploadPricesFileDialog.open = true;
            },
            closeUploadPricesFileDialog: (state) => {
                state.uploadPricesFileDialog = initialState.uploadPricesFileDialog;
            },
            // TODO: to delete old block later, during stock refactoring.
            selectCellItem: (state, action) => {
                const { cellId, inactive, item } = action.payload;
                if (state.cellSelection.cellId == cellId && state.cellSelection.inactive === inactive) {
                    state.cellSelection.items.push(item);
                }
                else {
                    state.cellSelection = {
                        cellId,
                        inactive,
                        items: [item],
                    };
                }
            },
            unselectCellItem: (state, action) => {
                state.cellSelection.items = state.cellSelection.items.filter((el) => el.stockItemId !== action.payload.stockItemId);
            },
            selectAll: (state, action) => {
                const { cellId, inactive, allItemsSelection } = action.payload;
                state.cellSelection.cellId = cellId;
                state.cellSelection.inactive = inactive;
                state.cellSelection.items = [...allItemsSelection];
            },
            unselectAll: (state) => {
                state.cellSelection = initialState.cellSelection;
                // Dialogs have to reset checkbox selection on submit and they might not know whether it is a cell view
                // selection or a balance view one.
                state.balanceSelection = initialState.balanceSelection;
            },
            selectCellItem_New: (state, action) => {
                const { cellName, inactive, item } = action.payload;
                if (state.cellSelection_New.cellName === cellName && state.cellSelection_New.inactive === inactive) {
                    state.cellSelection_New.items.push(item);
                }
                else {
                    state.cellSelection_New = {
                        cellName,
                        inactive,
                        items: [item],
                    };
                }
            },
            selectSingleCellItem: (state, action) => {
                // In Warehouse only a single row may be selected by user, since only relocation action is allowed there.
                const { cellName, inactive, item } = action.payload;
                state.cellSelection_New = {
                    cellName,
                    inactive,
                    items: [item],
                };
            },
            unselectCellItem_New: (state, action) => {
                state.cellSelection_New.items = state.cellSelection_New.items.filter((el) => el.id !== action.payload.id);
            },
            selectAll_New: (state, action) => {
                // const { cellId, inactive, allItemsSelection } = action.payload;
                // state.cellSelection.cellId = cellId;
                const { cellName, inactive, allItemsSelection } = action.payload;
                state.cellSelection_New.cellName = cellName;
                state.cellSelection_New.inactive = inactive;
                state.cellSelection_New.items = [...allItemsSelection];
            },
            unselectAll_New: (state) => {
                state.cellSelection_New = initialState.cellSelection_New;
                // Dialogs have to reset checkbox selection on submit and they might not know whether it is a cell view
                // selection or a balance view one.
                // state.balanceSelection = initialState.balanceSelection;
            },
            selectBalanceItem: (state, action) => {
                const { inactive, item } = action.payload;
                // TODO: check if inactive selection is necessary in this point. Now it does not count.
                if (state.balanceSelection.inactive === inactive) {
                    state.balanceSelection.items.push(item);
                }
                else {
                    state.balanceSelection = {
                        inactive,
                        items: [item],
                    };
                }
            },
            unselectBalanceItem: (state, action) => {
                state.balanceSelection.items = state.balanceSelection.items.filter((el) => el.stockBalanceId !== action.payload.stockBalanceId);
            },
            selectAllBalanceItems: (state, action) => {
                const { inactive, allItemsSelection } = action.payload;
                state.balanceSelection.inactive = inactive;
                state.balanceSelection.items = [...allItemsSelection];
            },
            // unselectAll should be used instead.
            // unselectAllBalanceItems: (state) => {
            // 	state.balanceSelection = initialState.balanceSelection;
            // },
            openRelocateStockItemDialog: (state) => {
                state.relocateStockItemDialog.open = true;
            },
            setRelocateErrorResponse: (state, action) => {
                state.relocateStockItemDialog.relocateErrorResponse = action.payload;
            },
            closeRelocateStockItemDialog: (state) => {
                state.relocateStockItemDialog = initialState.relocateStockItemDialog;
            },
            setBeingUpdatedCellId: (state, action) => {
                state.beingUpdatedCellId = action.payload.cellId;
            },
            ...reducers,
        },
    });
};
export { createSharedStockSlice, sharedStockInitialState };
